import React, { useEffect, useState } from "react";
import TextField from "@material-ui/core/TextField";
import { notBlank } from "../../util/ext";
import { useOrganizationPropertyKeys } from "../organizationServices";
import Autocomplete, {
  createFilterOptions,
} from "@material-ui/lab/Autocomplete";

const filter = createFilterOptions();

const PropertyComboBox = ({
  value,
  onChange,
  onBlur,
  error,
  helperText,
  label,
  placeholder,
}) => {
  const [propertyKeys, setPropertyKeys] = useState([]);

  const keysResponse = useOrganizationPropertyKeys();
  useEffect(() => {
    if (keysResponse.isSuccess && notBlank(keysResponse.data)) {
      setPropertyKeys(keysResponse.data);
    }
  }, [keysResponse.isSuccess, keysResponse.data]);

  const handleChange = (_event, value) => {
    const val =
      notBlank(value) && notBlank(value.inputValue) ? value.inputValue : value;
    onChange(val);
  };

  const [inputValue, setInputValue] = useState("");
  const handleKeyDown = event => {
    if (event.key === "Tab" && inputValue.length > 0) {
      handleChange(event, inputValue);
    }
  };

  return (
    <Autocomplete
      freeSolo
      handleHomeEndKeys
      id="property-key"
      options={propertyKeys}
      value={value}
      onChange={handleChange}
      inputValue={inputValue}
      onInputChange={(_event, val) => setInputValue(val)}
      getOptionLabel={option =>
        option.inputValue ? option.inputValue : option
      }
      filterOptions={(options, params) => {
        const filtered = filter(options, params);

        // Suggest the creation of a new value
        if (notBlank(params.inputValue)) {
          filtered.push(params.inputValue);
        }

        return filtered;
      }}
      renderInput={params => {
        params.inputProps.onKeyDown = handleKeyDown;
        return (
          <TextField
            {...params}
            variant="standard"
            label={label || "Property Key"}
            placeholder={placeholder || "Select or Enter New Key..."}
            onBlur={onBlur}
            error={error}
            helperText={helperText}
          />
        );
      }}
    />
  );
};

export default PropertyComboBox;
